import { PageDataContext } from "./PageData.context";

export function PageDataProvider({ children, value }) {
  return (
    <PageDataContext.Provider value={value}>
      {children}
    </PageDataContext.Provider>
  );
}
